import { DefaultColorPalette } from '../types/defaultColorPalette';

export const DEFAULT_ELEMENT_COLOR_PALETTES: DefaultColorPalette[] = [
  {
    inputColorHex: '#169FFF',
    inputColorName: 'insurance-rate',
    shades: [
      { name: '100', hex: '#ecf9ff' },
      { name: '200', hex: '#d5f0ff' },
      { name: '300', hex: '#b5e6ff' },
      { name: '400', hex: '#81d9ff' },
      { name: '500', hex: '#45c1ff' },
      { name: '600', hex: '#169FFF' },
      { name: '700', hex: '#0584ff' },
      { name: '800', hex: '#096add' },
      { name: '900', hex: '#0e54b2' },
      { name: '1000', hex: '#124a8c' },
      { name: '1100', hex: '#102d55' },
    ],
  },
  {
    inputColorHex: '#00A36C',
    inputColorName: 'estate-status',
    shades: [
      { name: '100', hex: '#eafff7' },
      { name: '200', hex: '#c8f5e4' },
      { name: '300', hex: '#99ebc7' },
      { name: '400', hex: '#64dba8' },
      { name: '500', hex: '#35c887' },
      { name: '600', hex: '#00A36C' },
      { name: '700', hex: '#008256' },
      { name: '800', hex: '#006947' },
      { name: '900', hex: '#004f36' },
      { name: '1000', hex: '#003d2a' },
      { name: '1100', hex: '#00261a' },
    ],
  },
  {
    inputColorHex: '#16A104',
    inputColorName: 'equity-rate',
    shades: [
      { name: '100', hex: '#edffe9' },
      { name: '200', hex: '#d2ffcb' },
      { name: '300', hex: '#a6ff9a' },
      { name: '400', hex: '#61ff4c' },
      { name: '500', hex: '#22e407' },
      { name: '600', hex: '#16A104' },
      { name: '700', hex: '#108600' },
      { name: '800', hex: '#0e7402' },
      { name: '900', hex: '#0d5205' },
      { name: '1000', hex: '#0b4306' },
      { name: '1100', hex: '#032600' },
    ],
  },
  {
    inputColorHex: '#16A104',
    inputColorName: 'savings-rate',
    shades: [
      { name: '100', hex: '#f2fbfa' },
      { name: '200', hex: '#d5f2ee' },
      { name: '300', hex: '#aae5de' },
      { name: '400', hex: '#78d0c7' },
      { name: '500', hex: '#4cb5ae' },
      { name: '600', hex: '#16A104' },
      { name: '700', hex: '#267b79' },
      { name: '800', hex: '#226362' },
      { name: '900', hex: '#1f5050' },
      { name: '1000', hex: '#1e4343' },
      { name: '1100', hex: '#0c2527' },
    ],
  },
  {
    inputColorHex: '#C035DD',
    inputColorName: 'burn-rate',
    shades: [
      { name: '100', hex: '#fbf4fe' },
      { name: '200', hex: '#f8e7fd' },
      { name: '300', hex: '#f0cefb' },
      { name: '400', hex: '#e7a7f6' },
      { name: '500', hex: '#d974ef' },
      { name: '600', hex: '#C035DD' },
      { name: '700', hex: '#a935be' },
      { name: '800', hex: '#822490' },
      { name: '900', hex: '#6a2075' },
      { name: '1000', hex: '#59205f' },
      { name: '1100', hex: '#3b0841' },
    ],
  },
  {
    inputColorHex: '#006E42',
    inputColorName: 'debt-rate',
    shades: [
      { name: '100', hex: '#e1fff3' },
      { name: '200', hex: '#b9ffe8' },
      { name: '300', hex: '#77ffd2' },
      { name: '400', hex: '#0fffb2' },
      { name: '500', hex: '#009b67' },
      { name: '600', hex: '#006E42' },
      { name: '700', hex: '#005c35' },
      { name: '800', hex: '#00482b' },
      { name: '900', hex: '#003824' },
      { name: '1000', hex: '#003121' },
      { name: '1100', hex: '#001a10' },
    ],
  },
  {
    inputColorHex: '#FFBD01',
    inputColorName: 'tax-rate',
    shades: [
      { name: '100', hex: '#fffeea' },
      { name: '200', hex: '#fffac5' },
      { name: '300', hex: '#fff785' },
      { name: '400', hex: '#ffec46' },
      { name: '500', hex: '#ffdd1b' },
      { name: '600', hex: '#FFBD01' },
      { name: '700', hex: '#e29100' },
      { name: '800', hex: '#bb6702' },
      { name: '900', hex: '#984f08' },
      { name: '1000', hex: '#7c410b' },
      { name: '1100', hex: '#482100' },
    ],
  },
  {
    inputColorHex: '#FF8C0C',
    inputColorName: 'liquid-term',
    shades: [
      { name: '100', hex: '#fff9ed' },
      { name: '200', hex: '#fff2d4' },
      { name: '300', hex: '#ffe1a8' },
      { name: '400', hex: '#ffcb70' },
      { name: '500', hex: '#ffa837' },
      { name: '600', hex: '#FF8C0C' },
      { name: '700', hex: '#f07106' },
      { name: '800', hex: '#c75507' },
      { name: '900', hex: '#9e430e' },
      { name: '1000', hex: '#7f390f' },
      { name: '1100', hex: '#451a05' },
    ],
  },
  {
    inputColorHex: '#8A31F1',
    inputColorName: 'qualified-term',
    shades: [
      { name: '100', hex: '#f9f5fe' },
      { name: '200', hex: '#f1e5fe' },
      { name: '300', hex: '#e4d0fc' },
      { name: '400', hex: '#cfacfa' },
      { name: '500', hex: '#b277f8' },
      { name: '600', hex: '#8A31F1' },
      { name: '700', hex: '#7a1de0' },
      { name: '800', hex: '#6723ae' },
      { name: '900', hex: '#57228d' },
      { name: '1000', hex: '#481c72' },
      { name: '1100', hex: '#2f0855' },
    ],
  },
  {
    inputColorHex: '#274ECC',
    inputColorName: 'real-estate-term',
    shades: [
      { name: '100', hex: '#eef3fd' },
      { name: '200', hex: '#d9e1f8' },
      { name: '300', hex: '#bbcdf5' },
      { name: '400', hex: '#8dacec' },
      { name: '500', hex: '#5680e2' },
      { name: '600', hex: '#274ECC' },
      { name: '700', hex: '#2b41ad' },
      { name: '800', hex: '#2c3996' },
      { name: '900', hex: '#29307a' },
      { name: '1000', hex: '#262d60' },
      { name: '1100', hex: '#1b1e3b' },
    ],
  },
  {
    inputColorHex: '#FF144F',
    inputColorName: 'business-term',
    shades: [
      { name: '100', hex: '#ffeef1' },
      { name: '200', hex: '#ffdee3' },
      { name: '300', hex: '#ffc3d0' },
      { name: '400', hex: '#ff91a7' },
      { name: '500', hex: '#ff547a' },
      { name: '600', hex: '#FF144F' },
      { name: '700', hex: '#ff054d' },
      { name: '800', hex: '#cb003a' },
      { name: '900', hex: '#aa0039' },
      { name: '1000', hex: '#910238' },
      { name: '1100', hex: '#520019' },
    ],
  },
  {
    inputColorHex: '#93CE00',
    inputColorName: 'total-term',
    shades: [
      { name: '100', hex: '#fbffe4' },
      { name: '200', hex: '#f4ffc5' },
      { name: '300', hex: '#e8ff92' },
      { name: '400', hex: '#d6ff53' },
      { name: '500', hex: '#c0fb20' },
      { name: '600', hex: '#93CE00' },
      { name: '700', hex: '#7cb500' },
      { name: '800', hex: '#5e8902' },
      { name: '900', hex: '#4b6c08' },
      { name: '1000', hex: '#405b0c' },
      { name: '1100', hex: '#203300' },
    ],
  },
] as const;
